import React from 'react';

export type ToastVariant = 'success' | 'error' | 'info';

export interface TaskToastAction {
  label: string;
  onClick: () => void;
}

export interface TaskToast {
  id: number;
  message: string;
  variant: ToastVariant;
  action?: TaskToastAction;
}

interface ToastStackProps {
  toasts: TaskToast[];
  onDismiss: (toastId: number) => void;
}

const ToastStack: React.FC<ToastStackProps> = ({ toasts, onDismiss }) => {
  if (toasts.length === 0) {
    return null;
  }

  const handleActionClick = (toast: TaskToast) => {
    toast.action?.onClick();
    onDismiss(toast.id);
  };

  return (
    <div className="task-toast-stack" aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`task-toast task-toast--${toast.variant}`}
          role={toast.variant === 'error' ? 'alert' : 'status'}
        >
          <div className="task-toast-content">
            <p className="task-toast-message">{toast.message}</p>
            {toast.action ? (
              <button
                type="button"
                className="task-toast-action"
                onClick={() => handleActionClick(toast)}
              >
                {toast.action.label}
              </button>
            ) : null}
          </div>
          <button
            type="button"
            className="task-toast-close"
            onClick={() => onDismiss(toast.id)}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastStack;